import React, { Component, createRef } from 'react';
import { TimelineMax } from 'gsap';
import './Bubble.styles.scss';

class Bubble extends Component {
    water = createRef();
    percent = 0;
    timeline = new TimelineMax();

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.animate();
    }

    componentDidMount() {
        this.animate();
    }

    animate = () => {
        this.timeline.kill();
        const from = [this.percent];
        const to = [this.props.value];
        to.onUpdate = () => {
            this.percent = from[0];
            if (this.water.current) {
                this.water.current.style.transform = `translate(0, ${100 - (this.percent)}%)`;
            }
        };
        this.timeline.to(from, 0.8, to);
    };

    render() {
        return (
            <div className="bubble">
                <div className="liquid"/>
                <div ref={this.water} id="water" className="water">
                    <svg viewBox="0 0 560 40" className="water_wave water_wave_front">
                        <path
                            d="M140 20C70 20 70 0 0 0V40H560V0C490 0 490 20 420 20C350 20 350 0 280 0C210 0 210 20 140 20Z"/>
                    </svg>
                </div>
            </div>
        );
    }
}

export default Bubble;